import Proptypes from 'prop-types';
import { branch, pure, compose, renderComponent } from 'recompose';
import {
  TemplateText,
  TemplateMultimediaCenter,
  TemplateMultimediaLeft
} from '.';
import { CENTER, LEFT, TEXT } from '../../../../constants/templates';

export const checkTemplateId = (temaplateId, values) =>
  values.some(value => value === temaplateId);

const Template = compose(
  branch(
    ({ templateId }) => checkTemplateId(templateId, TEXT),
    renderComponent(TemplateText)
  ),
  branch(
    ({ templateId }) => checkTemplateId(templateId, CENTER),
    renderComponent(TemplateMultimediaCenter)
  ),
  branch(
    ({ templateId }) => checkTemplateId(templateId, LEFT),
    renderComponent(TemplateMultimediaLeft)
  ),
  pure
)(TemplateText);

Template.propTypes = {
  templateId: Proptypes.string
};

export default Template;
